import { Component, computed, input, output } from '@angular/core';
import { UiChipComponent, UiNumberComponent, UIIconComponent } from '@design-system';
import { TransferHistoryItem } from '../wallet-transfer-history.model';
import { transferStateKey } from '../wallet-transfer-history.utils';

/**
 * One transfer as both lists draw it: the state's icon, the title with its state chip,
 * the amount and the date, and a chevron into the detail sheet.
 *
 * The host is the control — the row is a single press target, and a native `<button>`
 * is reserved for the design system — so it carries the button role and keyboard itself.
 */
@Component({
	selector: 'app-wallet-transfer-row',
	imports: [UiChipComponent, UiNumberComponent, UIIconComponent],
	templateUrl: './wallet-transfer-row.component.html',
	host: {
		class: 'flex w-full cursor-pointer items-center gap-3 text-right',
		dir: 'rtl',
		role: 'button',
		tabindex: '0',
		'aria-haspopup': 'dialog',
		'(click)': 'selected.emit()',
		'(keydown.enter)': 'selected.emit()',
		'(keydown.space)': '$event.preventDefault(); selected.emit()'
	}
})
export class WalletTransferRowComponent {
	readonly request = input.required<TransferHistoryItem>();
	/**
	 * The full history leaves a landed transfer's chip off — its icon already says so — and
	 * keeps one on every transfer still worth a second look.
	 */
	readonly hideCompletedChip = input(false);

	readonly selected = output<void>();

	readonly showChip = computed(
		() => !this.hideCompletedChip() || transferStateKey(this.request().state) !== 'completed'
	);
}
